/**
 * The label a CE DE MP scenario carries in the PDF, for every shipment that
 * reaches this substance - its own, and then those of every mixture it is in.
 *
 * That walk used to be written out here, over `rm.raw_material_suppliers` and
 * `rm.mixtures`. `shipmentsBySubstance` answers it in one lookup and in the same
 * order, direct first and then the mixtures, which matters: two shipments can
 * share an id key here, and the last one written wins.
 *
 * The other two indexes replace fields the nested shipment carried and the flat
 * one does not: `needsScenarioByShipment` for the registrations `needsScenario`
 * reads - without it every non-distributor answers "yes" - and `suppliersById`
 * because `shipment.supplier_id` is a number now.
 */
export default (substanceId, rawMaterialsById, shipmentsBySubstance, needsScenarioByShipment, suppliersById) => {

    const shipmentTagForSubstanceByShipmentID = {};

    (shipmentsBySubstance[substanceId] || []).forEach(({ rawMaterialId, shipment }) => {
            if (needsScenarioByShipment[shipment.id]) {
                const supplier = suppliersById[shipment.supplier_id];
                shipmentTagForSubstanceByShipmentID[shipment.id] =
                    `[ ${shipment.code} ] - [ ${rawMaterialsById[rawMaterialId].code} ] ${rawMaterialsById[rawMaterialId].name} - 
       [ ${supplier.code} ] ${supplier.name} - 
       ${shipment.trade_name}`;
            }
        }
    );

    return shipmentTagForSubstanceByShipmentID;
};
